'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002439 from "./presto.types$-Grouping-Name$$anon$39.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002440 from "./presto.types$-Grouping-Name$$anon$40.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingName$() {
  this.c7w = null;
  this.c7x = false;
  this.c7u = null;
  this.c7v = false;
  this.c7A = null;
  this.c7B = false;
  this.c7y = null;
  this.c7z = false;
  this.c7C = null;
  this.c7D = false;
}
export { $c_Lpresto_types$GroupingName$ as $c_Lpresto_types$GroupingName$ };
$p = $c_Lpresto_types$GroupingName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingName$;
/** @constructor */
function $h_Lpresto_types$GroupingName$() {
}
export { $h_Lpresto_types$GroupingName$ as $h_Lpresto_types$GroupingName$ };
$h_Lpresto_types$GroupingName$.prototype = $p;
$p.cs2 = (function() {
  if ((!this.c7x)) {
    this.c7w = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c7x = true;
  }
  return this.c7w;
});
$p.nL = (function() {
  if ((!this.c7v)) {
    this.c7u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c7v = true;
  }
  return this.c7u;
});
$p.csh = (function() {
  if ((!this.c7B)) {
    this.c7A = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7B = true;
  }
  return this.c7A;
});
$p.cIx = (function() {
  if ((!this.c7z)) {
    this.c7y = new $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002439.$c_Lpresto_types$GroupingName$$anon$39(this);
    this.c7z = true;
  }
  return this.c7y;
});
$p.cJ2 = (function() {
  if ((!this.c7D)) {
    this.c7C = new $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002440.$c_Lpresto_types$GroupingName$$anon$40(this);
    this.c7D = true;
  }
  return this.c7C;
});
var $d_Lpresto_types$GroupingName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingName$, "presto.types$GroupingName$", ({
  a0n: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingName$ as $d_Lpresto_types$GroupingName$ };
var $n_Lpresto_types$GroupingName$;
function $m_Lpresto_types$GroupingName$() {
  if ((!$n_Lpresto_types$GroupingName$)) {
    $n_Lpresto_types$GroupingName$ = new $c_Lpresto_types$GroupingName$();
  }
  return $n_Lpresto_types$GroupingName$;
}
export { $m_Lpresto_types$GroupingName$ as $m_Lpresto_types$GroupingName$ };
//# sourceMappingURL=presto.types$-Grouping-Name$.js.map
